export default "__VITE_ASSET__C_TUDKe1__"